import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'

/**
 * À quelle base l'application se connecte.
 *
 * ⚠️ Rien n'est écrit en dur ici : les valeurs viennent de `.env.beta` ou de
 * `.env.prod` selon l'environnement choisi AU MOMENT DE LA FABRICATION.
 *   npm run build:beta  → base de développement (aucun client)
 *   npm run build:prod  → production (clients réels)
 *
 * Il n'y a volontairement AUCUN repli : si l'environnement n'a pas été précisé,
 * la fabrication échoue (vite.config.ts) et, en dernier recours, l'application
 * refuse de démarrer ici. Un repli silencieux vers beta est exactement ce qui
 * ferait mettre en ligne une production branchée sur la base de test.
 *
 * Ces valeurs ne sont pas des secrets : la configuration Firebase d'une
 * application web part dans le navigateur de chaque visiteur. Ce sont
 * `firestore.rules` et `storage.rules` qui protègent les données.
 */
const env = import.meta.env as unknown as Record<string, string | undefined>

function requis(nom: string): string {
  const valeur = env[nom]
  if (!valeur) {
    throw new Error(
      `Configuration Firebase incomplète : ${nom} est absent. ` +
        'Cette version a été fabriquée sans préciser l\'environnement. ' +
        'Utiliser « npm run build:beta » ou « npm run build:prod » — jamais « vite build » seul.',
    )
  }
  return valeur
}

/** « beta » ou « prod ». Sert aux repères visuels et aux journaux. */
export const VZ_ENV = requis('VITE_VZ_ENV')

const firebaseConfig = {
  apiKey: requis('VITE_FB_API_KEY'),
  authDomain: requis('VITE_FB_AUTH_DOMAIN'),
  projectId: requis('VITE_FB_PROJECT_ID'),
  storageBucket: requis('VITE_FB_STORAGE_BUCKET'),
  messagingSenderId: requis('VITE_FB_MESSAGING_SENDER_ID'),
  appId: requis('VITE_FB_APP_ID'),
}

const app = initializeApp(firebaseConfig)

export const auth = getAuth(app)
export const db = getFirestore(app)
export const storage = getStorage(app)
export default app
